import styled from "styled-components";
import themes from '@/styles/themes'

const DetailsSubscriptionTitle=styled.h2`
  font-size: 16px;
  font-style: italic;
  color: ${themes.estadao};
  border-bottom: 1px solid ${themes.estadao};
  padding-bottom: 10px;
  font-weight: 600;
`
export default DetailsSubscriptionTitle